/* MD Patches - patches como linha de cobranca no carrinho (Horizon).
   Porte do assets/md-patches-carrinho.js da Premier Football (Dawn). Config vem de window.mdPatchesCfg =
   { variante, handle, checar } (escrito no layout/theme.liquid a partir de settings.md_patch_produto).
   Fluxo: ao submeter o form da camisa com patch marcado, intercepta o submit do Horizon e manda
   /cart/add com items:[extra, camisa]; as duas linhas levam a propriedade _md_tie (amarra) e a camisa
   guarda _md_patches = "P44@Right Sleeve,...". O drawer e atualizado pelo mesmo CartLinesUpdateEvent
   (@shopify/events) que o product-form-component do Horizon usa, com o HTML das secoes do carrinho.
   A reconciliacao mantem a quantidade do extra igual a (n de patches x quantidade da camisa). */
(function () {
  'use strict';
  if (window.__mdPatchesCarrinho) return;
  window.__mdPatchesCarrinho = true;
  var CFG = window.mdPatchesCfg || {};
  var VARIANTE = parseInt(CFG.variante, 10) || 0;
  var HANDLE = CFG.handle || 'patch';
  var ROTAS = (window.Theme && window.Theme.routes) || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var URL_ADD = ROTAS.cart_add_url || ROOT + 'cart/add';
  var URL_UPDATE = ROTAS.cart_update_url || ROOT + 'cart/update';
  var URL_CART = ROTAS.cart_url || ROOT + 'cart';
  var CHECAR_NA_CARGA = !!CFG.checar;
  var LOCAIS = ['Chest', 'Sleeve', 'Right Sleeve', 'Left Sleeve', 'Legacy', 'Sponsor', 'Match Details', 'Back Sponsor'];
  var ocupado = false, pendente = false, tentativasAdd = {}, MAX_ADD = 3, SE = null;

  function eventos() {
    if (SE) return Promise.resolve(SE);
    return import('https://cdn.shopify.com/storefront/standard-events.js').then(function (m) { SE = m; return m; }).catch(function () { return null; });
  }
  function jsonPost(url, corpo) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(corpo) });
  }
  function fnv(txt, semente) {
    var h = semente >>> 0;
    for (var i = 0; i < txt.length; i++) { h ^= txt.charCodeAt(i); h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0; }
    return h >>> 0;
  }
  function amarra(txt) { return 't' + fnv(txt, 2166136261).toString(36) + '-' + fnv(txt, 16777619).toString(36); }
  function contarCodigos(lista) { if (!lista) return 0; var n = 0; String(lista).split(',').forEach(function (p) { if (p.trim()) n++; }); return n; }
  function ehLinhaExtra(it) {
    if (!it) return false;
    if (it.properties && it.properties._md_addon === '1') return true;
    if (HANDLE && it.handle === HANDLE) return true;
    return false;
  }
  function secoesDoCarrinho() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId); });
    return ids;
  }

  /* ---------- interceptacao do add to cart ---------- */
  function escolhidos(f) {
    var vistos = [];
    function juntar(lista) { Array.prototype.forEach.call(lista, function (el) { if (vistos.indexOf(el) === -1) vistos.push(el); }); }
    juntar(f.querySelectorAll('input[data-md-patch-codigo]:checked'));
    var idDoForm = f.getAttribute('id');
    if (idDoForm) {
      var idSeguro = String(idDoForm).replace(/["\\\]]/g, '');
      juntar(document.querySelectorAll('[data-md-patches-form="' + idSeguro + '"] input[data-md-patch-codigo]:checked'));
    }
    var lista = [];
    vistos.forEach(function (el) {
      var codigo = (el.getAttribute('data-md-patch-codigo') || '').trim();
      var local = (el.getAttribute('data-md-patch-local') || '').trim();
      if (codigo) lista.push({ codigo: codigo, local: local });
    });
    lista.sort(function (a, b) {
      var ia = LOCAIS.indexOf(a.local), ib = LOCAIS.indexOf(b.local);
      if (ia < 0) ia = 99; if (ib < 0) ib = 99;
      if (ia !== ib) return ia - ib;
      if (a.local !== b.local) return a.local < b.local ? -1 : 1;
      if (a.codigo === b.codigo) return 0;
      return a.codigo < b.codigo ? -1 : 1;
    });
    return lista;
  }

  async function adicionarComPatches(f, patches) {
    var botao = f.querySelector('[name="add"], [type="submit"]');
    if (botao) { botao.setAttribute('aria-disabled', 'true'); botao.classList.add('loading'); }
    var adiado = null, adicionou = false, mod = await eventos();
    try {
      var fd = new FormData(f);
      var qtd = parseInt(fd.get('quantity'), 10) || 1;
      var idCamisa = fd.get('id');
      if (!idCamisa) throw new Error('form sem id de variante');
      var props = {}, chaves = [];
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) { props[m[1]] = v; chaves.push(m[1]); } });
      chaves.sort();
      var propsOrdenadas = chaves.map(function (k) { return k + '=' + props[k]; }).join(';');
      var plano = fd.get('selling_plan') || '';
      var codigos = patches.map(function (p) { return p.codigo + '@' + p.local; }).join(',');
      var locais = [];
      patches.forEach(function (p) { if (p.local && locais.indexOf(p.local) === -1) locais.push(p.local); });
      var tie = amarra(String(idCamisa) + '|' + codigos + '|' + propsOrdenadas + '|' + plano);
      props['Patches'] = patches.map(function (p) { return p.codigo; }).length + (locais.length ? ' (' + locais.join(', ') + ')' : '');
      props['_md_patches'] = codigos;
      props['_md_tie'] = tie;
      var camisa = { id: idCamisa, quantity: qtd, properties: props };
      if (plano) camisa.selling_plan = plano;
      var extra = { id: VARIANTE, quantity: patches.length * qtd, properties: { _md_tie: tie, _md_addon: '1' } };
      /* extra primeiro no array: o /cart/add lista na ordem inversa, entao a camisa aparece antes do extra */
      var corpo = { items: [extra, camisa] };
      var secoes = secoesDoCarrinho();
      if (secoes.length) { corpo.sections = secoes.join(','); corpo.sections_url = window.location.pathname; }
      var alvo = f.closest('product-form-component') || f;
      if (mod && mod.CartLinesUpdateEvent) {
        adiado = mod.CartLinesUpdateEvent.createPromise();
        alvo.dispatchEvent(new mod.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(idCamisa), quantity: qtd }, { merchandiseId: String(VARIANTE), quantity: extra.quantity }], promise: adiado.promise }));
      }
      var res = await jsonPost(URL_ADD, corpo);
      if (!res.ok) throw new Error('cart/add ' + res.status);
      adicionou = true;
      var resp = await res.json();
      if (resp && resp.status) throw new Error(resp.description || resp.message || 'cart/add');
      var ajaxCart = await (await fetch(URL_CART + '.json', { headers: { Accept: 'application/json' } })).json();
      if (adiado) {
        adiado.resolve({ cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart), detail: { items: ajaxCart.items, source: 'md-patches', sourceId: '', itemCount: qtd, productId: '', sections: resp.sections, didError: false } });
        adiado = null;
      } else {
        window.location.href = URL_CART;
      }
    } catch (e) {
      if (adiado && adiado.reject) { try { adiado.reject(e); } catch (e2) {} }
      if (!adicionou) { try { HTMLFormElement.prototype.submit.call(f); } catch (e3) {} }
      else window.location.href = URL_CART;
    } finally {
      if (botao) { botao.removeAttribute('aria-disabled'); botao.classList.remove('loading'); }
    }
  }

  if (VARIANTE) {
    document.addEventListener('submit', function (ev) {
      var f = ev.target, patches;
      try {
        if (!f || !f.getAttribute) return;
        var acao = f.getAttribute('action') || '';
        if (acao.indexOf('/cart/add') === -1) return;
        var campoId = f.querySelector('[name="id"]');
        if (!campoId || !campoId.value) return;
        if (String(campoId.value) === String(VARIANTE)) return;
        patches = escolhidos(f);
        if (!patches.length) return;
      } catch (e) { return; }
      ev.preventDefault();
      ev.stopImmediatePropagation();
      adicionarComPatches(f, patches);
    }, true);
  }

  /* ---------- reconciliacao ---------- */
  async function repintar(resp) {
    try {
      var mod = await eventos();
      if (!mod || !mod.CartLinesUpdateEvent || !resp) return;
      var ajaxCart = await (await fetch(URL_CART + '.json', { headers: { Accept: 'application/json' } })).json();
      var adiado = mod.CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new mod.CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [], promise: adiado.promise }));
      adiado.resolve({ cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart), detail: { items: ajaxCart.items, source: 'md-patches', sourceId: '', itemCount: 0, productId: '', sections: resp.sections, didError: false } });
    } catch (e) {}
  }
  async function reconciliar() {
    if (ocupado) { pendente = true; return; }
    ocupado = true;
    try {
      var carrinho = await (await fetch(URL_CART + '.js', { headers: { Accept: 'application/json' } })).json();
      var itens = (carrinho && carrinho.items) || [], grupos = {}, updates = {}, mudou = false;
      itens.forEach(function (it) {
        var tie = it.properties && it.properties._md_tie;
        if (!tie) return;
        if (!grupos[tie]) grupos[tie] = { alvo: 0, extras: [] };
        if (ehLinhaExtra(it)) grupos[tie].extras.push(it);
        else grupos[tie].alvo += contarCodigos(it.properties._md_patches) * it.quantity;
      });
      var faltando = [];
      Object.keys(grupos).forEach(function (tie) {
        var g = grupos[tie], total = 0;
        g.extras.forEach(function (e) { total += e.quantity; });
        if (total === g.alvo) return;
        if (!g.extras.length) { if (g.alvo > 0 && VARIANTE) faltando.push({ tie: tie, qtd: g.alvo }); return; }
        g.extras.forEach(function (e, i) { var nova = i === 0 ? g.alvo : 0; if (nova !== e.quantity) { updates[e.key] = nova; mudou = true; } });
      });
      itens.forEach(function (it) { if (!ehLinhaExtra(it)) return; var tie = it.properties && it.properties._md_tie; if (!tie) { updates[it.key] = 0; mudou = true; } });
      var addOk = false;
      for (var i = 0; i < faltando.length; i++) {
        var tieFalta = faltando[i].tie;
        tentativasAdd[tieFalta] = (tentativasAdd[tieFalta] || 0) + 1;
        if (tentativasAdd[tieFalta] > MAX_ADD) continue;
        try {
          var resAdd = await jsonPost(URL_ADD, { items: [{ id: VARIANTE, quantity: faltando[i].qtd, properties: { _md_tie: tieFalta, _md_addon: '1' } }] });
          if (resAdd && resAdd.ok) addOk = true;
        } catch (e) {}
      }
      if (!mudou) { if (addOk) { pendente = false; setTimeout(reconciliar, 0); } return; }
      var corpo = { updates: updates };
      var secoes = secoesDoCarrinho();
      if (secoes.length) { corpo.sections = secoes.join(','); corpo.sections_url = window.location.pathname; }
      var res = await jsonPost(URL_UPDATE, corpo);
      if (!res.ok) return;
      var resp = await res.json();
      await repintar(resp);
    } catch (e) {
    } finally {
      ocupado = false;
      if (pendente) { pendente = false; reconciliar(); }
    }
  }
  function instalarGatilhos() {
    eventos().then(function (mod) {
      if (mod && mod.StandardEvents && mod.StandardEvents.cartLinesUpdate) {
        document.addEventListener(mod.StandardEvents.cartLinesUpdate, function (ev) {
          var p = ev && ev.promise;
          if (!p || !p.then) { setTimeout(reconciliar, 120); return; }
          p.then(function (r) { var d = r && r.detail; if (d && d.source === 'md-patches') return; setTimeout(reconciliar, 60); }).catch(function () {});
        });
      }
    });
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && window.MutationObserver) {
      var tDom = 0;
      new MutationObserver(function () { clearTimeout(tDom); tDom = setTimeout(reconciliar, 400); }).observe(drawer, { childList: true, subtree: true });
    }
    if (CHECAR_NA_CARGA) reconciliar();
  }
  if (document.readyState === 'complete') instalarGatilhos(); else window.addEventListener('load', instalarGatilhos);
})();
